const hasNonEmptyString = (value) => typeof value === 'string' && value.trim().length > 0;
// BE compares `between` with lte; a bare date would exclude the end day after midnight.
const END_OF_DAY_SUFFIX = 'T23:59:59.999999';
export const toEndOfDay = (date) => (date ? `${date}${END_OF_DAY_SUFFIX}` : '');
export const stripEndOfDay = (value) => value.endsWith(END_OF_DAY_SUFFIX) ? value.slice(0, -END_OF_DAY_SUFFIX.length) : value;
export const defaultValuesForOperator = (operator) => operator === 'is_null' ? [true] : [];
export const valuesAreCompatible = (oldOperator, newOperator) => {
    const multiOperators = ['in', 'not_in'];
    const singleOperators = ['after', 'before', 'contains'];
    return ((multiOperators.includes(oldOperator) && multiOperators.includes(newOperator)) ||
        (singleOperators.includes(oldOperator) && singleOperators.includes(newOperator)));
};
const validateValues = (filter) => {
    const { operator, values } = filter;
    if (operator === 'is_null') {
        return values.length === 1 && typeof values[0] === 'boolean'
            ? null
            : 'Choose “Is null” or “Is not null”.';
    }
    if (operator === 'between') {
        return values.length === 2 && values.every(hasNonEmptyString)
            ? null
            : 'Choose both the start and end dates.';
    }
    if (operator === 'after' || operator === 'before' || operator === 'contains') {
        return values.length === 1 && hasNonEmptyString(values[0]) ? null : 'Enter a value.';
    }
    if (operator === 'in' || operator === 'not_in') {
        const validValues = values.every((value) => typeof value === 'boolean' || hasNonEmptyString(value));
        return values.length > 0 && validValues ? null : 'Add at least one value.';
    }
    return 'Enter a valid value.';
};
export const validateSegmentFilters = (filters, attributes) => {
    const errors = [];
    filters.forEach((filter, index) => {
        if (!filter.attribute) {
            errors.push({ index, field: 'attribute', message: 'Select an attribute.' });
            return;
        }
        const attribute = attributes.find((candidate) => candidate.name === filter.attribute);
        if (!attribute) {
            errors.push({
                index,
                field: 'attribute',
                message: 'This attribute is no longer available. Refresh attributes.'
            });
            return;
        }
        if (!attribute.operators.includes(filter.operator)) {
            errors.push({
                index,
                field: 'operator',
                message: 'Select an operator supported by this attribute.'
            });
            return;
        }
        const valueError = validateValues(filter);
        if (valueError)
            errors.push({ index, field: 'value', message: valueError });
    });
    return errors;
};
export const getFilterControlId = (idPrefix, index, field, operator) => {
    const rowId = `${idPrefix}-${index}`;
    if (field === 'attribute')
        return `${rowId}-attribute`;
    if (field === 'operator')
        return `${rowId}-operator`;
    if (operator === 'is_null')
        return `${rowId}-value-true`;
    if (operator === 'between')
        return `${rowId}-value-start`;
    return `${rowId}-value`;
};
